import styled from "@emotion/styled";

export const TextInputRootBase = styled("div")`
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 40px;
`;
